import React from 'react';
import { Box,Typography } from '@mui/material';
import ClientTable from './ClientsSideNav/ClientsSideNav';
import ReactTable from './Dashboard/Dashboard'

const ClientListDetails = () => {

  return (
    <Box sx={{ display: 'flex',height:'100vh' }}>
      {/* <LeftSidenav /> */}
      <ClientTable />
      <Box component="main" sx={{ flexGrow: 1, p: 3,overflowY:'auto' }}>
        <ReactTable />
      </Box>
    </Box>
  );
};

export default ClientListDetails;
